import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import {initReactI18next} from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import languageEN from './locales/en/translate.json'
import languageHI from './locales/hi/translate.json'
import languageKN from './locales/kn/translate.json'
import languageTA from './locales/ta/translate.json'
import languageTE from './locales/te/translate.json'
import { getLanguage } from './utils/common'

i18n
.use(XHR)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    resources: {
        en: languageEN,
        hi: languageHI,
        kn: languageKN,
        ta: languageTA,
        te: languageTE
    },
    /* default language when load the website in browser */
    lng: getLanguage(),
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})

export default i18n;